export const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/`;
export default API_URL;
